module.exports = __webpack_public_path__ + "51f525471a618cc8bece1c04cdf0832b.png";